import { FormErrorResponse } from '../errors/error-response';

/** Base class for API errors. */
export class APIError extends Error {
  readonly errors?: any;

  constructor(message: string, errors?: any) {
    super(message);
    this.errors = errors;
  }
}

/** Base class for HTTP errors. */
export class HTTPError extends APIError {
  readonly response: Response;

  constructor(message: string, response: Response, errors?: any) {
    super(message, errors);
    this.response = response;
  }

  get status() {
    return this.response.status;
  }
}

/** HTTP 400 Bad request */
export class BadRequestError extends HTTPError {
  constructor(response: Response, errors?: FormErrorResponse) {
    super('Bad request', response, errors);
  }
}

/** HTTP 401 Not authenticated */
export class AuthenticationError extends HTTPError {
  constructor(response: Response, errors?: any) {
    super('Not authenticated', response, errors);
  }
}

/** HTTP 403 Forbidden */
export class ForbiddenError extends HTTPError {
  constructor(response: Response, errors?: any) {
    super('Forbidden', response, errors);
  }
}

/** HTTP 404 Not Found */
export class NotFoundError extends HTTPError {
  constructor(response: Response, errors?: any) {
    super('Not found', response, errors);
  }
}

/** HTTP 405 Method not allowed */
export class MethodNotAllowedError extends HTTPError {
  constructor(response: Response, errors?: any) {
    super('Method not allowed', response, errors);
  }
}

/** HTTP 5xx Internal server errors */
export class InternalServerError extends HTTPError {
  readonly html?: string;

  constructor(response: Response, html?: string) {
    super(response.statusText, response);
    this.html = html;
  }
}

/** Parameter validation error */
export class ValidationError extends APIError {
  readonly parameter: string;

  constructor(message: string, parameter: string) {
    super(message, {
      [parameter ? parameter : '__all__']: [message]
    });
    this.parameter = parameter;
  }
}
